var React = require('react');

function Search (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M7.14214 13.2843C10.5344 13.2843 13.2843 10.5344 13.2843 7.14214C13.2843 3.74993 10.5344 1 7.14214 1C3.74993 1 1 3.74993 1 7.14214C1 10.5344 3.74993 13.2843 7.14214 13.2843Z","strokeWidth":"1.67781","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M11.6699 11.6698L18.0096 18.0095","strokeWidth":"1.59601","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Search.defaultProps = {"viewBox":"0 0 19 19"};

module.exports = Search;

Search.default = Search;
